import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as links from 'documents-lib/js/lib/links';
import { trackInteraction } from 'documents-lib/js/tracking/tracker';
import { CLICK_SHARE_COMPOSE_EMAIL, CLICK_SHARE_COPY_LINK } from 'documents-lib/js/tracking/actions';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareShortlink = ({
  email,
  name,
  shortLink,
  sharedWithVid
}) => {
  const handleClickCopyLink = useCallback(() => {
    trackInteraction(CLICK_SHARE_COPY_LINK);
  }, []);
  const handleClickComposeEmail = useCallback(() => {
    trackInteraction(CLICK_SHARE_COMPOSE_EMAIL);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "300",
      as: "p",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLink.shortLink.description",
        options: {
          email
        }
      })
    }), /*#__PURE__*/_jsx(CopyInput, {
      "data-selenium-test": "share-short-link-copy-input",
      onCopy: handleClickCopyLink,
      value: shortLink
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      typography: "heading-25",
      marginBlock: "300",
      display: "block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLink.shortLink.or"
      })
    }), /*#__PURE__*/_jsx(Button, {
      href: links.getContactEmailURL(sharedWithVid, name, shortLink),
      onClick: handleClickComposeEmail,
      size: "small",
      target: "_blank",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createLink.shortLink.emailFromCRM"
      })
    })]
  });
};
export default ShareShortlink;